/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { getSlotsNext } from '@fluentui/react-utilities';
import { Portal } from '@fluentui/react-portal';
/**
 * Render the final JSX of MenuPopover
 */ export const renderMenuPopover_unstable = (state)=>{
    const { slots , slotProps  } = getSlotsNext(state);
    if (state.inline) {
        return /*#__PURE__*/ createElement(slots.root, slotProps.root);
    }
    return /*#__PURE__*/ createElement(Portal, {
        mountNode: state.mountNode
    }, /*#__PURE__*/ createElement(slots.root, slotProps.root));
};
